import { Goal, Task, Timestamp } from '@griply/types';
import { computeGoalTaskProgress } from '@griply/utils';
import { useMemo } from 'react';

import { useTimeframeDifference } from './use-timeframe-difference';

export type UseGoalTaskProgressOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
  allTasks: Task[];
};

export const useGoalTaskProgress = (
  goal: Goal,
  { startDate, endDate, allTasks }: UseGoalTaskProgressOptions,
) => {
  const { entries, target, completionPercentage } = useMemo(
    () => computeGoalTaskProgress({ goal, allTasks }),
    [goal, allTasks],
  );

  const timeframeDifference = useTimeframeDifference({
    entries,
    startDate,
    endDate,
    target,
  });

  return {
    allTasks,
    entries,
    target,
    completionPercentage,
    timeframeDifference,
  };
};
